import React from "react";
import { connect } from "react-redux";
import { isStringEmpty } from "lib/validate";

import * as paysafeCustom from "components/school_money/basket/checkout/paysafe/paysafe";

import { getSchoolByID, getCheckoutTotalToPay } from "state/school_money/selectors";
import { processCheckoutTransaction, closeCheckout, paysafeError } from "state/school_money/actions";

import Button from "components/Button";
import Currency from "components/Currency";
import SchoolLogo from "components/school_money/SchoolLogo";

import "./PaymentForm.css";
import cvvIcon from "components/assets/images/cvv.svg";
import acceptedCardLogos from "components/assets/images/accepted-card-logos.svg";
const paysafeLogo = "https://developer.paysafe.com/fileadmin/content/logos/powered_by_Paysafe_standard.png";

class PaymentForm extends React.Component {
  
  instance = undefined;
  
  state = {
    cardholderName: "",
    isFieldValid: {
      CardholderName: false,
      CardNumber: false,
      Cvv: false,
      ExpiryDate: false
    },
    isFieldHighlighted: {
      CardholderName: false,
      CardNumber: false,
      Cvv: false,
      ExpiryDate: false
    }
  }
  
  onCardholderNameChange = event => {
    const { value } = event.target;
    const isValid = !isStringEmpty(value);
    this.setState({ cardholderName: value, });
    this.setFieldState("CardholderName", isValid);
    this.unhighlightField("CardholderName");
  }
  
  pay = () => {
    if (this.isAllValid()) {
      paysafeCustom.tokenize(this.instance, this.props.totalToPay, this.props.school, this.state.cardholderName)
        .then(result => {
          this.props.processTransaction(result.token, this.state.cardholderName);
        }, this.props.onError);
    } else {
      this.highlightInvalidFields();
    }
  }
  
  isAllValid() {
    return Object.values(this.state.isFieldValid).every(isValid => isValid);
  }
  
  setFieldState(fieldName, isValid) {
    this.setState({
      isFieldValid: {
        ...this.state.isFieldValid,
        [fieldName]: isValid
      }
    })
  }
  
  highlightInvalidFields() {
    const isFieldHighlighted = Object.entries(this.state.isFieldValid)
      .reduce((isFieldHighlighted, [ fieldName, isValid ]) => ({
        ...isFieldHighlighted,
        [fieldName]: !isValid
      }), {})
    this.setState({ isFieldHighlighted });
  }
  
  unhighlightField(fieldName) {
    this.setState({
      isFieldHighlighted: {
        ...this.state.isFieldHighlighted,
        [fieldName]: false
      }
    })
  }
  
  componentDidMount() {
    paysafeCustom.setup()
      .then(instance => {
        this.instance = instance;
        instance.fields("cardNumber cvv expiryDate").on("Valid Invalid", (instance, event) => {
          const isValid = event.type === "Valid";
          this.setFieldState(event.target.fieldName, isValid);
        });
        instance.fields("cardNumber cvv expiryDate").on("FieldValueChange", (instance, event) => {
          this.unhighlightField(event.target.fieldName);
        });
      }, this.props.onError);
  }
  
  renderCardholderNameInput() {
    const isHighlighted = this.state.isFieldHighlighted.CardholderName;
    const classNames = [ "checkout-payment__input" ];
    if (isHighlighted) {
      classNames.push("checkout-payment__input--highlighted");
    }
    return (
      <div className={classNames.join(" ")}>
        <input
          className="checkout-payment__name-input"
          placeholder="Your Name"
          value={this.state.cardholderName}
          onChange={this.onCardholderNameChange}
        />
      </div>
    )
  }
  
  renderPaysafeInput(fieldName, className) {
    const isHighlighted = this.state.isFieldHighlighted[fieldName];
    const classNames = [ "checkout-payment__input", className ];
    if (isHighlighted) {
      classNames.push("checkout-payment__input--highlighted");
    }
    return (
      <div className={classNames.join(" ")} id={`paysafe${fieldName}`}></div>
    );
  }
  
  render() {
    
    const { school, totalToPay } = this.props;
    
    const cssModifier = this.isAllValid() ? "valid" : "invalid";
    const classNames = [ "checkout-payment", `checkout-payment--${cssModifier}` ];
    const isTestEnvironment = paysafeCustom.environment === "TEST";
    
    return (
      <div className={classNames.join(" ")}>
        <div className="checkout-payment__header">
          <div className="checkout-payment__total-to-pay">
            <div className="checkout-payment__total-to-pay-label">Total To Pay</div>
            <div className="checkout-payment__total-to-pay-amount">
              <Currency amount={totalToPay} />
            </div>
          </div>
          <div className="checkout-payment__school">
            <SchoolLogo cssBlockName="checkout-payment" school={school} />
          </div>
        </div>
        <div className="checkout-payment__input-container">
          <div className="checkout-payment__input-row">
            <div className="checkout-payment__input-cell">
              <div className="checkout-payment__input-label">Cardholder Name</div>
              { this.renderCardholderNameInput() }
            </div>
          </div>
          <div className="checkout-payment__input-row">
          <div className="checkout-payment__input-cell">
            <div className="checkout-payment__input-label">Card Number
            <img className="checkout-payment__card-logos" src={acceptedCardLogos} alt="Mastercard, Visa" /></div>
            { this.renderPaysafeInput("CardNumber", "checkout-payment__card-number") }
          </div>

          </div>
          <div className="checkout-payment__input-row">
            <div className="checkout-payment__input-cell">
              <div className="checkout-payment__input-label">Expires</div>
              { this.renderPaysafeInput("ExpiryDate", "checkout-payment__expiry-date") }
            </div>
            <div className="checkout-payment__input-cell">
              <div className="checkout-payment__input-label">CVV <img className="checkout-payment__cvv-icon" src={cvvIcon} alt="CVV" /></div>
              { this.renderPaysafeInput("Cvv", "checkout-payment__cvv") }
            </div>
          </div>
        </div>
        <div className="checkout-payment__button-container">
          <Button className="checkout-payment__cancel-button" onClick={this.props.onClose}>Cancel</Button>
          <Button className="checkout-payment__pay-button" onClick={this.pay}>Pay Now</Button>
        </div>
        <div className="checkout-payment__footer">
          Powered by <img className="checkout-payment__paysafe-logo" src={paysafeLogo} alt="Paysafe" />
        </div>
        { isTestEnvironment ? <div className="checkout-payment__environment-indicator">TEST environment</div> : null }
      </div>
    )
    
  }
  
}

export default connect(
  (state, { schoolID }) => ({
    school: getSchoolByID(state, schoolID),
    totalToPay: getCheckoutTotalToPay(state)
  }),
  {
    processTransaction: processCheckoutTransaction,
    onClose: closeCheckout,
    onError: paysafeError
  }
)(PaymentForm);



// WEBPACK FOOTER //
// ./src/components/school_money/basket/checkout/paysafe/PaymentForm.js